var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sort"},[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"mt-1",attrs:{"fab":"","outline":"","small":""},on:{"click":function($event){return _vm.$emit("click")}}},on),[_c('v-icon',[_vm._v("sort")])],1)]}}])},[_c('span',[_vm._v("Сортировка списка")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }